import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useCmsData } from '../../hooks/useCmsData';
import CmsArticleTeaser from './CmsArticleTeaser';

interface ICmsArticleTeaserList {
    startDate: string,
    endDate: string,
    headline: string,
    skipFirst?: boolean,
    language: ("de" | "en")
}

const CmsArticleTeaserList : React.FC<ICmsArticleTeaserList> = ({startDate, endDate, language, headline, skipFirst}) => {
    const [data, loading, error] = useCmsData<Array<{_id: string, category: string}>>({
        docType: "article", 
        additonalQueryString: `&& language == '${language}' && _createdAt >= '${startDate}'  && _createdAt <= '${endDate}'`, 
        fields: `
        _id,
        category
    `});

    let responseData = data;
    if(skipFirst === true) {
        responseData = responseData?.filter((_val, i) => i !== 0);
    }
    return <>
        {(loading || error || (responseData && responseData.length > 0)) && <Typography variant='h2'>{headline}</Typography>}
        <Grid container gap={'1em'}>
            {!loading && !error && responseData?.map(d => <Grid item xs={12} sm={6} md={3} ><CmsArticleTeaser id={d?._id} language={language} /></Grid>)}
        </Grid>
    </>
}

export default CmsArticleTeaserList;